import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { IonicModule } from '@ionic/angular';
import { CoreModule } from 'src/app/core/models/core.module';
import { FilesModalComponent } from './files-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, CoreModule, MatMenuModule, TranslateModule],
  declarations: [FilesModalComponent],
  exports: [FilesModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FilesModalModule { }
